<template>
  <div class="container">
    <div class="card">
      <div class="card-body">
        <p class="card-title fs-6 text-center">{{ messagePacket }}</p>
        <p class="card-text fs-4 text-center fw-bold">{{ price }}</p>
        <p class="card-text ">mensagen por R${{ amount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardsComponent",
  props:{
    messagePacket: String,
    price: String,
    amount: String
  },
  data() {
    return {
      msg: "selected plan",
    };
  },
  created() {
    console.log(this.messagePacket);
    console.log(this.values);
  },
};
</script>

<style scoped>
.card {
  background-color: #34a9fc;
  color: white;
  border-radius: 15px;
  border: none;
  font-size: 10px;
  margin-top: 20px;
  right: 13px;
}
</style>